type Change = {
  audit_id?: number;
  at?: string;
  actor_name?: string;
  reason?: string | null;
  reversible?: boolean;
  before?: { value?: unknown } | null;
  after?: { value?: unknown } | null;
};

function displayValue(value: unknown): string {
  if (value == null) return '—';
  if (typeof value === 'object') return 'Updated';
  return String(value);
}

export function AccountantChangeDigest({ changes = [], onReverse }: { changes?: Array<Record<string, unknown> | Change>; onReverse?: (auditId: number) => void }) {
  const normalized = changes as Change[];
  const groups = normalized.reduce<Record<string, Change[]>>((result, change) => {
    const date = change.at?.slice(0, 10) ?? 'Date unavailable';
    (result[date] ??= []).push(change);
    return result;
  }, {});
  return (
    <aside className="rounded-[10px] border border-border bg-card p-4" aria-labelledby="accountant-change-digest-heading">
      <h2 id="accountant-change-digest-heading" className="font-semibold">Changes by your accountant · {normalized.length}</h2>
      {normalized.length === 0 ? <p className="mt-2 text-sm text-muted-foreground">No changes recorded yet.</p> : Object.entries(groups).map(([date, dayChanges]) => (
        <div key={date} className="mt-3">
          <h3 className="text-xs font-semibold text-muted-foreground">{date}</h3>
          <div className="divide-y divide-border">
            {dayChanges.map((change) => (
              <article key={change.audit_id ?? `${date}-${change.reason ?? 'change'}`} className={`py-3 text-sm ${change.reversible === false ? 'text-muted-foreground line-through' : ''}`}>
                <div className="flex justify-between"><span>{change.actor_name ?? 'Accountant'}</span><span>{displayValue(change.before?.value)} → {displayValue(change.after?.value)}</span></div>
                <p className="mt-1 text-xs text-muted-foreground">{change.reason ?? 'No reason recorded'}</p>
                {change.reversible && change.audit_id != null && onReverse && <button type="button" onClick={() => onReverse(change.audit_id!)} className="mt-2 min-h-11 text-link">Reverse</button>}
              </article>
            ))}
          </div>
        </div>
      ))}
    </aside>
  );
}

export default AccountantChangeDigest;

